import React from 'react';
import { t } from '@lingui/macro';
import { withI18n } from '@lingui/react';
import { connect } from 'react-redux';
import { Pagination } from 'antd';

/**
 * Custom Pagination which is not included as a props of Table
 * Props:
 * - paginationData (required): {current:int, total:int, pageSize:int/String}
 * - onPageChange (required) : function call when page is changed
 * - restProps: any other props that apply to antd Pagination
 */
function CustomPagination(props) {
    // component props
    const {
        // values
        paginationData,

        // redux
        view,
        gridSize,

        // actions
        onPageChange,
        ...restProps
    } = props;

    function getShowSizeChanger() {
        if (view === "MobileView")
            return false;
        return paginationData.showSizeChanger ? paginationData.showSizeChanger : true;
    }

    const showSizeChanger = getShowSizeChanger();
    // if no data
    if (paginationData.total) {
        return (
            <Pagination
                size={gridSize === 'xs' ? 'small' : 'medium'}
                simple={gridSize === 'xs'}
                total={paginationData.total}
                current={paginationData.current}
                // requires conditional to prevent error during initial render where pagination == {}
                pageSize={paginationData.pageSize ? paginationData.pageSize : 30}
                defaultCurrent={1}
                showLessItems
                showSizeChanger={showSizeChanger}
                pageSizeOptions={[10, 30, 50, 100]}
                showTotal={(total, range) => t`${range[0]}-${range[1]} of ${total} items`}
                onChange={onPageChange}
                {...restProps}
            />
        );
    }
    return null;
}

export default connect(state => ({
    view: state.App.view,
    gridSize: state.App.gridSize,
}))(withI18n()(CustomPagination));
